/**
 * Best-effort localization of canonical shift-template names that exist in the
 * database in Hungarian. The backend currently stores a single `name` field per
 * template, so we map known Hungarian names → t() keys client-side.
 *
 * If a name isn't in the dictionary we just return it unchanged.
 */
const KEY_MAP = {
  "Délelőtt": "tpl.morning",
  "Délelötti": "tpl.morning",
  "Délutáni": "tpl.afternoon",
  "Délután": "tpl.afternoon",
  "Esti": "tpl.evening",
  "Este": "tpl.evening",
  "Éjszaka": "tpl.night",
  "Éjszakai": "tpl.night",
  "Nappal": "tpl.day",
  "Nappali": "tpl.day",
  "Hétvége": "tpl.weekend",
  "Hétvégi": "tpl.weekend",
  "Hosszú": "tpl.long",
  "Hosszú nap": "tpl.long_day",
  "Rövid": "tpl.short",
  "Pultos": "tpl.bartender",
  "Felszolgáló": "tpl.waiter",
  "Konyhás": "tpl.kitchen",
};

export function localizeTemplateName(name, t) {
  if (!name) return name;
  const trimmed = String(name).trim();
  const key = KEY_MAP[trimmed];
  if (!key) return name;
  // Fallback chain: localized -> original Hungarian name
  return t(key, { defaultValue: name });
}
